import { mainnet as mainnetChain } from '@reown/appkit/networks';
export function mainnet(node) {
    return {
        ...mainnetChain,
        rpcUrls: {
            default: {
                http: [node],
            },
        },
    };
}
